import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import { getWhatsAppStatusAsync } from "../../services/subcriptionApi";
// import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";
import { useDispatchWrapper } from "../../hooks";
import { fetchOrgEnvConfigListAsync } from "../../redux/orgEnvConfig/orgEnvConfigActions";
import { IStoreState } from "../../redux/initialStoreState";

interface IWhatsAppStatusContext {
  useMetaService: boolean | null;
  whatsappNumber: string;
  loading: boolean;
  error: string | null;
  refreshStatus: () => void;
}

const WhatsAppStatusContext = createContext<IWhatsAppStatusContext | undefined>(
  undefined
);

export const useWhatsAppStatus = () => {
  const context = useContext(WhatsAppStatusContext);
  if (context === undefined) {
    throw new Error(
      "useWhatsAppStatus must be used within a WhatsAppStatusProvider"
    );
  }
  return context;
};

interface IWhatsAppStatusProviderProps {
  children: React.ReactNode;
}

export const WhatsAppStatusProvider: React.FC<IWhatsAppStatusProviderProps> = ({
  children,
}) => {
  const [useMetaService, setUseMetaService] = useState<boolean | null>(null);
  const [whatsappNumber, setWhatsappNumber] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // const companyOutlet = useBillingCompanyContext();
  const dispatch = useDispatchWrapper();

  const { list: orgEnvConfigList } = useSelector(
    (storeState: IStoreState) => storeState.orgEnvConfig
  );

  const fetchWhatsAppStatus = useCallback(async () => {
    // if (!companyOutlet.comapny.company_outlet_uuid) return;

    setLoading(true);
    setError(null);

    try {
      await getWhatsAppStatusAsync(
        // companyOutlet.comapny.company_outlet_uuid,
        (data, isSuccess) => {
          if (isSuccess && data.data) {
            setUseMetaService(data.data.use_meta_service);
          } else {
            setUseMetaService(false);
            setError("Failed to fetch WhatsApp status");
          }
        }
      );
    } catch (err) {
      console.error("Error fetching WhatsApp status:", err);
      setUseMetaService(false);
      setError("Error fetching WhatsApp status");
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshStatus = useCallback(() => {
    fetchWhatsAppStatus();
  }, [fetchWhatsAppStatus]);

  // Fetch org env config to get WhatsApp number
  useEffect(() => {
    // if (companyOutlet.comapny.company_outlet_uuid) {
      dispatch(
        fetchOrgEnvConfigListAsync(
          1,
          100,
          // companyOutlet.comapny.company_outlet_uuid
        )
      );
    // }
  }, [dispatch]);

  // Extract WhatsApp number from environment configuration
  useEffect(() => {
    if (orgEnvConfigList && orgEnvConfigList.length > 0) {
      const whatsappConfig = orgEnvConfigList.find(
        (config) => config.env_key === "WHATSAPP_NUMBER"
      );
      if (whatsappConfig && whatsappConfig.env_value) {
        setWhatsappNumber(whatsappConfig.env_value);
      } else {
        setWhatsappNumber("");
      }
    } else {
      setWhatsappNumber("");
    }
  }, [orgEnvConfigList]);

  // Fetch status when company outlet changes
  useEffect(() => {
    fetchWhatsAppStatus();
  }, [fetchWhatsAppStatus]);

  const value: IWhatsAppStatusContext = {
    useMetaService,
    whatsappNumber,
    loading,
    error,
    refreshStatus,
  };

  return (
    <WhatsAppStatusContext.Provider value={value}>
      {children}
    </WhatsAppStatusContext.Provider>
  );
};
